import { chatActions as chat } from "./chatActions";
export const actions = {
  chat,
};
